<div id="loaderDiv" *ngIf="show">
    <div class="ajax-loadernew">
        <img src="assets/images/rms-loader.gif" style="width:90px;">
        <p style="display:inline-block;width:50%;text-align: center;font-size: 16px;font-family: Roboto-Bold;color:#2a3b4d;margin-left: 10px;">Loading... </p>
    </div>
</div>